import CartButton from 'components/CartButton';
import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { Stack } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import Logo from 'components/Logo';
import { isApp } from 'utils/app';
import { env } from 'constants';
import { LayoutContext } from 'constants/contexts';
import AddressButton from './AddressButton';
import SearchModal from './SearchModal';
import { HeaderElements } from './constants';
import BackButton from './BackButton';
import Title from './Title';
import ProfileButton from './ProfileButton';

function HeaderMobile({ visibleElements, title, onBack }) {
  const [searchOpen, setSearchOpen] = useState(false);
  const { headerHeight } = React.useContext(LayoutContext);
  function renderIfVisible(name, element) {
    if (visibleElements.includes(name)) {
      return element;
    }
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="space-between"
      alignItems="center"
      flex={1}
      width="100%"
      height={headerHeight}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        flexShrink={1}
        minWidth={0}
        width="100%"
        sx={{ height: '100%' }}
      >
        {renderIfVisible(HeaderElements.BACK_BUTTON, <BackButton onBack={onBack} />)}
        {!isApp() && renderIfVisible(HeaderElements.LOGO, <Logo />)}
        {title &&
          renderIfVisible(HeaderElements.TITLE, typeof title === 'string' ? <Title title={title} /> : title)}
        {renderIfVisible(HeaderElements.ADDRESS_BUTTON, <AddressButton />)}
      </Stack>
      <Stack direction="row" alignItems="center" spacing={2}>
        {
          !env.IS_MARKETPLACE && (
            renderIfVisible(
              HeaderElements.SEARCH, (
                <IconButton onClick={() => setSearchOpen(true)} sx={{ p: 0 }}>
                  <SearchIcon />
                </IconButton>
              ),
            )
          )
        }
        {(env.IS_CATERING || !env.IS_MARKETPLACE) && renderIfVisible(HeaderElements.CART_BUTTON, <CartButton />)}
        {(env.IS_CATERING || !env.IS_MARKETPLACE) && renderIfVisible(HeaderElements.USER_BUTTON, <ProfileButton />)}
      </Stack>
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
    </Stack>
  );
}
export default HeaderMobile;
